import { useState } from 'react';
import { blogPosts } from '../../../mocks/blogPosts';
import BlogCard from './BlogCard';
import BlogModal from './BlogModal';
import type { BlogPost } from '../../../mocks/blogPosts';

interface BlogGridProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const BlogGrid = ({ selectedCategory, onCategoryChange }: BlogGridProps) => {
  const [selectedPost, setSelectedPost] = useState<BlogPost | null>(null);

  const categories = [
    { id: 'all', label: 'All Stories' },
    { id: 'home-birth', label: 'Home Birth' },
    { id: 'hospital-birth', label: 'Hospital Birth' },
    { id: 'vbac', label: 'VBAC' },
    { id: 'postpartum', label: 'Postpartum' },
  ];

  const filteredPosts = selectedCategory === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                selectedCategory === category.id
                  ? 'bg-amber-700 text-white shadow-md'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.map((post) => (
            <BlogCard 
              key={post.id} 
              post={post} 
              onClick={() => setSelectedPost(post)}
            />
          ))}
        </div>

        {filteredPosts.length === 0 && (
          <div className="text-center py-20">
            <i className="ri-file-list-3-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-gray-500 text-lg">No stories found in this category yet.</p>
          </div>
        )}
      </div>

      {/* Blog Modal */}
      {selectedPost && (
        <BlogModal 
          post={selectedPost} 
          onClose={() => setSelectedPost(null)} 
        />
      )}
    </section>
  );
};

export default BlogGrid;